export const dataLibJ = [{
  word: 'jako',
  partOfSpeech: 'N',
  definition: ['St. Lucian parrot'],
  egSentenceKw: 'La ni an chay jako an léfowé sé jou sala.',
  egSentenceEn: 'There are a lot of St. Lucian parrots in the forest these days.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jacquot]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jou',
  partOfSpeech: 'N',
  definition: ['day'],
  egSentenceKw: 'Ki jou ou kay viwé?',
  egSentenceEn: 'What day will you return?',
  synonym: [null],
  antonym: ['swè'],
  etymology: '[< Fr. jour]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jòn',
  partOfSpeech: 'ADJ',
  definition: ['yellow'],
  egSentenceKw: 'Kay-la té pentiwé an jòn.',
  egSentenceEn: 'The house was painted yellow.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jaune]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jilyé',
  partOfSpeech: 'N',
  definition: ['waistcoat'],
  egSentenceKw: 'Mwen pa kay mété jilyé jòdi-a paski i ka fè twò cho.',
  egSentenceEn: 'I am not going to put on a waistcoat today because it is too hot.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. gilet]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jip',
  partOfSpeech: 'N',
  definition: ['skirt'],
  egSentenceKw: 'I pòté on jip kout.',
  egSentenceEn: 'She wore a short skirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jupe]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jòdi',
  partOfSpeech: 'ADV',
  definition: ['today (in a general sense)', 'nowadays'],
  egSentenceKw: 'Manmay jòdi pa kon manmay lontan.',
  egSentenceEn: 'Children today are not like children in the past.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. aujourd\'hui]',
  dialect: '🇱🇨',
  variant: ['hòdi'],
}, {
  word: 'jis',
  partOfSpeech: 'PREP',
  definition: ['until'],
  egSentenceKw: 'Nou pé wèsté jis lanné ka vini.',
  egSentenceEn: 'We may stay until next year.',
  synonym: ['jis a tan', 'jis lè', 'jis tan', 'jisannatandan', 'jiskatan'],
  antonym: [null],
  etymology: '[< Fr. jusque]',
  dialect: '🇱🇨',
  variant: ['jik'],
}, {
  word: 'jis',
  partOfSpeech: 'PREP',
  definition: ['as far as', 'up to'],
  egSentenceKw: 'Yo maché pou wivé jis an hòtè.',
  egSentenceEn: 'They walked until they reached the countryside.',
  synonym: ['jis a tan', 'jis lè', 'jis tan', 'jisannatandan', 'jiskatan'],
  antonym: [null],
  etymology: '[< Fr. jusque]',
  dialect: '🇱🇨',
  variant: ['jik'],
}, {
  word: 'jis',
  partOfSpeech: 'ADV',
  definition: ['even'],
  egSentenceKw: 'Jis sé madanm-lan ki alé wè sé manmay-la jwé bol.',
  egSentenceEn: 'Even the women went to see the children playing cricket.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juste]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jis',
  partOfSpeech: 'ADV',
  definition: ['exactly', 'precisely'],
  egSentenceKw: 'I mennwit jis.',
  egSentenceEn: 'It is exactly midnight.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juste]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jis',
  partOfSpeech: 'ADV',
  definition: ['just'],
  egSentenceKw: 'Bondyé asé jis pou pawdonnen péché nou.',
  egSentenceEn: 'God is just enough to forgive our sins.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juste]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jis',
  partOfSpeech: 'ADV',
  definition: ['tight'],
  egSentenceKw: 'Tjilòt tibway-la jis tèlman i pa sa menm bésé.',
  egSentenceEn: 'The boy\'s trousers are so tight he cannot even bend over.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. juste]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jibyé',
  partOfSpeech: 'N',
  definition: ['bird'],
  egSentenceKw: 'Jibyé kontan ti gwenn sala.',
  egSentenceEn: 'Birds like that little seed.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ja',
  partOfSpeech: 'ADV',
  definition: ['already'],
  egSentenceKw: 'Lè nou wivé yo té ja la.',
  egSentenceEn: 'When we arrived they were already there.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. déja]',
  dialect: '🇱🇨',
  variant: ['ha', 'za'],
}, {
  word: 'jwé',
  partOfSpeech: 'V',
  definition: ['to play'],
  egSentenceKw: 'Sé ti manmay-la toujou ka jwé.',
  egSentenceEn: 'The children always play.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jouer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jwé',
  partOfSpeech: 'V',
  definition: ['to enjoy'],
  egSentenceKw: 'Nonm-lan jwé blag madanm-lan.',
  egSentenceEn: 'The man enjoyed the lady\'s jokes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jouer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'jwé',
  partOfSpeech: 'N',
  definition: ['game'],
  egSentenceKw: 'Sa sé on bèl jwé.',
  egSentenceEn: 'That is a nice game.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jouer]',
  dialect: '🇱🇨',
  variant: [null],
},
];
